import React from 'react';
import { FrameProps } from 'types/common/PropsTypes';

const FrameSection = ({ addClassName, textAlign, children }: FrameProps) => {
  return <section className={`section-primary ${addClassName ?? ''} ${textAlign ?? ''}`}>{children}</section>;
};

export default React.memo(FrameSection);
